// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

.dashboard-header {
    margin-bottom: 30px;
}

.dashboard-header h1 {
    font-size: 2rem;
    color: #1a1a2e;
    margin: 0;
}

.dashboard-header p {
    color: #666;
    margin: 5px 0 0;
}

/* Stats Grid */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.stat-card {
    background: white;
    border-radius: 12px;
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    border: 1px solid #edf2f7;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    border-color: #4299e1;
}

.stat-icon {
    font-size: 2rem;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
}

.stat-content {
    flex: 1 1;
}

.stat-value {
    font-size: 1.8rem;
    font-weight: 700;
    color: #1a1a2e;
    margin: 0;
}

.stat-title {
    font-size: 0.95rem;
    color: #666;
    margin: 2px 0 0;
}

.stat-subtitle {
    font-size: 0.8rem;
    color: #999;
}

/* Dashboard Sections */
.dashboard-sections {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.section-card {
    background: white;
    border-radius: 12px;
    padding: 18px 22px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    border: 1px solid #edf2f7;
}

.section-card h2 {
    font-size: 1.05rem;
    font-weight: 700;
    color: #2d3748;
    margin: 0 0 14px;
    padding-bottom: 10px;
    border-bottom: 1px solid #edf2f7;
}

.empty-state {
    text-align: center;
    padding: 30px;
    color: #999;
}

.empty-state p {
    margin-bottom: 15px;
}

.btn-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    transition: transform 0.2s, box-shadow 0.2s;
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

/* Bottom: Ações Rápidas + Alertas side by side */
.dashboard-bottom {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-top: 20px;
    align-items: start;
}

/* Quick Actions */
.quick-actions {
    margin-top: 0;
}

.quick-actions h2 {
    font-size: 1.1rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0 0 20px 0;
}

.actions-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 12px;
}

.quick-action-card.qa-encomenda:hover span:last-child {
    color: #3182ce;
}

/* Alertas e Avisos */
.alertas-panel h2 {
    display: flex;
    align-items: center;
    gap: 8px;
}

.alertas-count-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #fee2e2;
    color: #991b1b;
    font-size: 0.75rem;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 20px;
    margin-left: 4px;
}

.alertas-urgente-dot {
    width: 7px;
    height: 7px;
    background: #dc2626;
    border-radius: 50%;
    display: inline-block;
    animation: pulse-dot 1.4s infinite;
}

@keyframes pulse-dot {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.3; }
}

.alertas-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 340px;
    overflow-y: auto;
    padding-right: 4px;
}

.alertas-list::-webkit-scrollbar { width: 5px; }
.alertas-list::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }

.alertas-empty {
    text-align: center;
    color: #94a3b8;
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
}

.alerta-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid;
    transition: opacity 0.15s;
}

.alerta-tipo-icon {
    font-size: 1.2rem;
    flex-shrink: 0;
    width: 24px;
    text-align: center;
}

.alerta-info {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
}

.alerta-nome {
    font-size: 0.85rem;
    font-weight: 600;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.alerta-doc {
    font-size: 0.75rem;
    color: #64748b;
}

.alerta-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 3px;
    flex-shrink: 0;
}

.alerta-validade {
    font-size: 0.75rem;
    color: #475569;
    font-weight: 500;
}

.alerta-dias-badge {
    font-size: 0.7rem;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 10px;
    white-space: nowrap;
}

.quick-action-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 16px 12px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #4a5568;
    text-decoration: none;
    width: 100%;
    min-height: 110px;
}

.quick-action-card:hover {
    background: white;
    border-color: #3182ce;
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(49, 130, 206, 0.1);
}

.quick-action-card span:first-child {
    font-size: 1.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s;
}

.quick-action-card:hover span:first-child {
    transform: scale(1.1);
}

.quick-action-card span:last-child {
    font-size: 0.85rem;
    font-weight: 600;
    color: #2d3748;
    text-align: center;
    line-height: 1.2;
}

.quick-action-card:hover span:last-child {
    color: #3182ce;
}

/* Dashboard Tables */
.dashboard-table-container {
    max-height: 280px;
    overflow-y: auto;
    padding-right: 5px;
}

.dashboard-table-container::-webkit-scrollbar {
    width: 6px;
}

.dashboard-table-container::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 10px;
}

.dashboard-table {
    width: 100%;
    border-collapse: collapse;
}

.dashboard-table th,
.dashboard-table td {
    padding: 12px 10px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
}

.dashboard-table th {
    font-size: 0.8rem;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 600;
}

.dashboard-table tr:hover {
    background: #f9fafb;
}

.dashboard-table td {
    font-size: 0.9rem;
    color: #333;
}

.status-badge {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: capitalize;
}

.status-badge.planeada {
    background: #edf2f7;
    color: #4a5568;
}

.status-badge.em_curso {
    background: #def7ec;
    color: #03543f;
}

.status-badge.concluida {
    background: #e1effe;
    color: #1e429f;
}

.expiry-warning {
    color: #e53e3e;
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yCAAyC;IACzC,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;IAC/C,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,iDAAiD;AACjD;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,YAAY,EAAE;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,mCAAmC,UAAU,EAAE;AAC/C,yCAAyC,mBAAmB,EAAE,mBAAmB,EAAE;;AAEnF;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,2BAA2B;IAC3B,oDAAoD;AACxD;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".dashboard {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100%;\r\n}\r\n\r\n.dashboard-header {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.dashboard-header h1 {\r\n    font-size: 2rem;\r\n    color: #1a1a2e;\r\n    margin: 0;\r\n}\r\n\r\n.dashboard-header p {\r\n    color: #666;\r\n    margin: 5px 0 0;\r\n}\r\n\r\n/* Stats Grid */\r\n.stats-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\r\n    gap: 20px;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.stat-card {\r\n    background: white;\r\n    border-radius: 12px;\r\n    padding: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n    border: 1px solid #edf2f7;\r\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.stat-card:hover {\r\n    transform: translateY(-4px);\r\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\r\n    border-color: #4299e1;\r\n}\r\n\r\n.stat-icon {\r\n    font-size: 2rem;\r\n    width: 60px;\r\n    height: 60px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 12px;\r\n}\r\n\r\n.stat-content {\r\n    flex: 1;\r\n}\r\n\r\n.stat-value {\r\n    font-size: 1.8rem;\r\n    font-weight: 700;\r\n    color: #1a1a2e;\r\n    margin: 0;\r\n}\r\n\r\n.stat-title {\r\n    font-size: 0.95rem;\r\n    color: #666;\r\n    margin: 2px 0 0;\r\n}\r\n\r\n.stat-subtitle {\r\n    font-size: 0.8rem;\r\n    color: #999;\r\n}\r\n\r\n/* Dashboard Sections */\r\n.dashboard-sections {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\r\n    gap: 20px;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.section-card {\r\n    background: white;\r\n    border-radius: 12px;\r\n    padding: 18px 22px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n    border: 1px solid #edf2f7;\r\n}\r\n\r\n.section-card h2 {\r\n    font-size: 1.05rem;\r\n    font-weight: 700;\r\n    color: #2d3748;\r\n    margin: 0 0 14px;\r\n    padding-bottom: 10px;\r\n    border-bottom: 1px solid #edf2f7;\r\n}\r\n\r\n.empty-state {\r\n    text-align: center;\r\n    padding: 30px;\r\n    color: #999;\r\n}\r\n\r\n.empty-state p {\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.btn-primary {\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 0.9rem;\r\n    font-weight: 500;\r\n    transition: transform 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.btn-primary:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\r\n}\r\n\r\n/* Bottom: Ações Rápidas + Alertas side by side */\r\n.dashboard-bottom {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n    align-items: start;\r\n}\r\n\r\n/* Quick Actions */\r\n.quick-actions {\r\n    margin-top: 0;\r\n}\r\n\r\n.quick-actions h2 {\r\n    font-size: 1.1rem;\r\n    font-weight: 700;\r\n    color: #1a202c;\r\n    margin: 0 0 20px 0;\r\n}\r\n\r\n.actions-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\r\n    gap: 12px;\r\n}\r\n\r\n.quick-action-card.qa-encomenda:hover span:last-child {\r\n    color: #3182ce;\r\n}\r\n\r\n/* Alertas e Avisos */\r\n.alertas-panel h2 {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.alertas-count-badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    background: #fee2e2;\r\n    color: #991b1b;\r\n    font-size: 0.75rem;\r\n    font-weight: 700;\r\n    padding: 2px 8px;\r\n    border-radius: 20px;\r\n    margin-left: 4px;\r\n}\r\n\r\n.alertas-urgente-dot {\r\n    width: 7px;\r\n    height: 7px;\r\n    background: #dc2626;\r\n    border-radius: 50%;\r\n    display: inline-block;\r\n    animation: pulse-dot 1.4s infinite;\r\n}\r\n\r\n@keyframes pulse-dot {\r\n    0%, 100% { opacity: 1; }\r\n    50% { opacity: 0.3; }\r\n}\r\n\r\n.alertas-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    max-height: 340px;\r\n    overflow-y: auto;\r\n    padding-right: 4px;\r\n}\r\n\r\n.alertas-list::-webkit-scrollbar { width: 5px; }\r\n.alertas-list::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }\r\n\r\n.alertas-empty {\r\n    text-align: center;\r\n    color: #94a3b8;\r\n    padding: 32px 16px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.alerta-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 10px 12px;\r\n    border-radius: 8px;\r\n    border: 1px solid;\r\n    transition: opacity 0.15s;\r\n}\r\n\r\n.alerta-tipo-icon {\r\n    font-size: 1.2rem;\r\n    flex-shrink: 0;\r\n    width: 24px;\r\n    text-align: center;\r\n}\r\n\r\n.alerta-info {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1px;\r\n    min-width: 0;\r\n}\r\n\r\n.alerta-nome {\r\n    font-size: 0.85rem;\r\n    font-weight: 600;\r\n    color: #1e293b;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.alerta-doc {\r\n    font-size: 0.75rem;\r\n    color: #64748b;\r\n}\r\n\r\n.alerta-right {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n    gap: 3px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.alerta-validade {\r\n    font-size: 0.75rem;\r\n    color: #475569;\r\n    font-weight: 500;\r\n}\r\n\r\n.alerta-dias-badge {\r\n    font-size: 0.7rem;\r\n    font-weight: 700;\r\n    padding: 2px 7px;\r\n    border-radius: 10px;\r\n    white-space: nowrap;\r\n}\r\n\r\n.quick-action-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 12px;\r\n    padding: 16px 12px;\r\n    background: #f8fafc;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 12px;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    color: #4a5568;\r\n    text-decoration: none;\r\n    width: 100%;\r\n    min-height: 110px;\r\n}\r\n\r\n.quick-action-card:hover {\r\n    background: white;\r\n    border-color: #3182ce;\r\n    transform: translateY(-4px);\r\n    box-shadow: 0 10px 15px -3px rgba(49, 130, 206, 0.1);\r\n}\r\n\r\n.quick-action-card span:first-child {\r\n    font-size: 1.8rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 48px;\r\n    height: 48px;\r\n    background: white;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n    transition: transform 0.2s;\r\n}\r\n\r\n.quick-action-card:hover span:first-child {\r\n    transform: scale(1.1);\r\n}\r\n\r\n.quick-action-card span:last-child {\r\n    font-size: 0.85rem;\r\n    font-weight: 600;\r\n    color: #2d3748;\r\n    text-align: center;\r\n    line-height: 1.2;\r\n}\r\n\r\n.quick-action-card:hover span:last-child {\r\n    color: #3182ce;\r\n}\r\n\r\n/* Dashboard Tables */\r\n.dashboard-table-container {\r\n    max-height: 280px;\r\n    overflow-y: auto;\r\n    padding-right: 5px;\r\n}\r\n\r\n.dashboard-table-container::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.dashboard-table-container::-webkit-scrollbar-thumb {\r\n    background: #e2e8f0;\r\n    border-radius: 10px;\r\n}\r\n\r\n.dashboard-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.dashboard-table th,\r\n.dashboard-table td {\r\n    padding: 12px 10px;\r\n    text-align: left;\r\n    border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.dashboard-table th {\r\n    font-size: 0.8rem;\r\n    color: #888;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n    font-weight: 600;\r\n}\r\n\r\n.dashboard-table tr:hover {\r\n    background: #f9fafb;\r\n}\r\n\r\n.dashboard-table td {\r\n    font-size: 0.9rem;\r\n    color: #333;\r\n}\r\n\r\n.status-badge {\r\n    padding: 4px 10px;\r\n    border-radius: 20px;\r\n    font-size: 0.75rem;\r\n    font-weight: 600;\r\n    text-transform: capitalize;\r\n}\r\n\r\n.status-badge.planeada {\r\n    background: #edf2f7;\r\n    color: #4a5568;\r\n}\r\n\r\n.status-badge.em_curso {\r\n    background: #def7ec;\r\n    color: #03543f;\r\n}\r\n\r\n.status-badge.concluida {\r\n    background: #e1effe;\r\n    color: #1e429f;\r\n}\r\n\r\n.expiry-warning {\r\n    color: #e53e3e;\r\n    font-weight: 600;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
